// Most call sites sit in `useAsyncData` with a `watch`, so the same fetch runs
// during SSR and again in the browser on client-side navigation. Only the SSR
// pass may hold the token; the browser pass is proxied.
export const fetchQueryPath = (path: string) => {
  if (import.meta.client) {
    return $fetch('/api/strapi-rest', { query: { path } })
  }

  const runtimeConfig = useRuntimeConfig()

  return $fetch(`${runtimeConfig.strapiPrivateUrl || runtimeConfig.strapiPublicUrl}/api/${path}`, {
    headers: {
      Authorization: `Bearer ${runtimeConfig.strapiAccessToken}`,
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  })
}
